import {
  COLOR_SCALE_MAP,
  COLORS,
  CYCLICAL_COLOR_SCALE_MAP,
  CyclicalColors,
  DIVERGING_COLORS_SCALE_MAP,
  DivergingColors,
  GradientColors,
  QUALITATIVE_COLOR_SCALE_MAP,
  QualitativeColors
} from "@/constants/colors";
import { MAX_STEP } from "@/constants/dataset";
import { EColorNames } from "@/types/dataset";

export const getColorScaleMap = (color: EColorNames, stepValue: number) => {
  if (GradientColors.includes(color)) {
    return COLOR_SCALE_MAP[stepValue];
  } else if (QualitativeColors.includes(color)) {
    return QUALITATIVE_COLOR_SCALE_MAP[stepValue];
  } else if (DivergingColors.includes(color)) {
    return DIVERGING_COLORS_SCALE_MAP[stepValue];
  } else if (CyclicalColors.includes(color)) {
    return CYCLICAL_COLOR_SCALE_MAP[stepValue];
  } else {
    return COLOR_SCALE_MAP[MAX_STEP];
  }
};

export const getClampedColor = (
  color: EColorNames,
  scale: ReturnType<typeof getColorScaleMap>,
  index: number
) => {
  const clampedIndex = Math.min(Math.max(index, 0), scale.length - 1);
  return COLORS[color][scale[clampedIndex]];
};
